import { render, staticRenderFns } from "./DescargasActividadPantalla.vue?vue&type=template&id=6e834b6a&"
import script from "./DescargasActividadPantalla.vue?vue&type=script&lang=ts&"
export * from "./DescargasActividadPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports